<template>
    <div class="relative z-100" v-click-outside="closeMenu">
        <div class="flex items-center cursor-pointer mr-2.5" @click="menuHandler">
            <div class="relative rounded-full p-1.5 w-15 h-15 border-2 border-gray-200 dark:border-purple-100">
                <div class="rounded-full bg-gray dark:bg-purple-100 w-full h-full"></div>
            </div>

            <ArrowDownIcon class="ml-4.5 transform duration-300" :class="{ 'rotate-180': menu }"/>
        </div>

        <div
            class="absolute right-0 top-offset-full-4 bg-white w-57 px-3 py-3 border border-gray-250 rounded-lg transition-all duration-300 ease-in z-10"
            :class="{ 'hidden': !menu }"
        >
            <div
                v-for="(item, index) in items"
                :key="index"
                class="rounded-lg bg-white hover:bg-gray cursor-pointer"
                :class="{ 'mt-2': index }"
            >
                <router-link class="flex py-2.5" :to="{ name: item.routeName }">
                    <span class="text-gray-800 text-lg whitespace-nowrap px-4">{{ item.name }}</span>
                </router-link>
            </div>

            <div class="py-2.5 w-full">
                <div class="opacity-20 h-px bg-gray-800"></div>
            </div>

            <div
                class="rounded-lg bg-white hover:bg-gray cursor-pointer py-2.5"
                @click="logOut"
            >
                <span class="text-gray-800 text-lg whitespace-nowrap px-4">Logout</span>
            </div>
        </div>
    </div>
</template>

<script>
import ArrowDownIcon from '@/components/icons/ArrowDownIcon'

import { mapActions } from 'vuex'
import { Types as authTypes } from '@/store/modules/authTypes'

export default {
    name: 'AccountMenu',
    components: { ArrowDownIcon },
    data: () => ({
        menu: false,
        items: [
            { name: 'Dashboard', routeName: 'Dashboard' },
            // { name: 'Profile' },
            { name: 'Settings', routeName: 'Settings' },
            // { name: 'Help Center' },
            // { name: 'Customer Support' },
        ]
    }),
    methods: {
        ...mapActions({
            logOut: authTypes.actions.LOG_OUT
        }),
        menuHandler() {
            this.menu = !this.menu
        },
        closeMenu() {
            this.menu = false
        },
    },
}
</script>
